import constants from 'constants';

const {
  CREATE_CALENDAR_BOOKING,
  ADD_CALENDAR_BOOKINGS,
  LOAD_CALENDAR_BOOKINGS,
  ADD_CALENDAR_BOOKING,
  ADD_BOOKING_HOLIDAYS,
  UPDATE_CALENDAR_SAGA,
  LOAD_ADMIN_CALENDAR_BOOKINGS,
  LOAD_SPONSOR_BOOKINGS,
  ADD_ADMIN_CALENDAR_BOOKINGS,
  ADMIN_BOOKINGS_APPROVE_REJECT,
  PUT_ADMIN_CALENDAR_BOOKING,
  LOAD_CALENDAR_BOOKING,
  ADD_CALENDAR_EDIT_BOOKING,
  ADD_CALENDAR_SPONSOR_BOOKINGS,
  ADMIN_DELETE_BOOKINGS_SAGA
} = constants;

export const createCalendarBooking = (data) => ({
  type: CREATE_CALENDAR_BOOKING,
  data
})

export const addCalendarBooking = (booking) => ({
  type: ADD_CALENDAR_BOOKING,
  payload: booking
})

export const addCalendarBookings = (bookings) => ({
  type: ADD_CALENDAR_BOOKINGS,
  payload: bookings
})

export const addCalendarSponsorBookings = (bookings) => ({
  type: ADD_CALENDAR_SPONSOR_BOOKINGS,
  payload: bookings
})

export const addAdminCalendarBookings = (bookings) => ({
  type: ADD_ADMIN_CALENDAR_BOOKINGS,
  payload: bookings
})

export const loadCalendarBookings = (period, userTypes = [0,1,2,3,4,5,6,7,8,11]) => ({
  type: LOAD_CALENDAR_BOOKINGS,
  period,
  userTypes
})

export const loadCalendarBooking = (id) => ({
  type: LOAD_CALENDAR_BOOKING,
  id
})

export const loadAdminCalendarBookings = (query, page = 1) => ({
  type: LOAD_ADMIN_CALENDAR_BOOKINGS,
  ...query,
  page
})
export const loadSponsorBookings = (query, page = 1) => ({
  type: LOAD_SPONSOR_BOOKINGS,
  ...query,
  page
})

export const adminBookingsApproveReject = (id, bookingType) => ({
  type: ADMIN_BOOKINGS_APPROVE_REJECT,
  id,
  bookingType
})

export const adminDeleteBookingSaga = (booking_ids, query) => ({
  type: ADMIN_DELETE_BOOKINGS_SAGA,
  booking_ids,
  query
})

export const putAdminCalendarBooking = (booking) => ({
  type: PUT_ADMIN_CALENDAR_BOOKING,
  payload: booking
})

export const updateCalendarSaga = (booking) => ({
  type: UPDATE_CALENDAR_SAGA,
  booking
})

export const addCalendarEditBookings = (booking) => ({
  type: ADD_CALENDAR_EDIT_BOOKING,
  payload: booking
})

export const addBookingHolidays = (holidays) => ({
  type: ADD_BOOKING_HOLIDAYS,
  payload: holidays
})



// WEBPACK FOOTER //
// ./src/actions/calendar.js